import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Icon } from '../../ui';
import { Categoria } from '../../servicos/categorias/typeCategoria';
import { Transacao } from '../../servicos/transacoes/typeTransacao';
import { valorParaTexto } from '../../utils/Utils';
import { dataCurta, hexToRgba } from './uteis';
import styles from './UltimasCard.module.css';

type UltimasCardProps = {
  transacoes: Transacao[];
  categorias: Categoria[];
};

/** As 8 movimentações mais recentes do período, com link para a tela completa. */
export default function UltimasCard({ transacoes, categorias }: UltimasCardProps) {
  const navigate = useNavigate();

  const ultimas = useMemo(() => {
    return [...transacoes]
      .sort((a, b) => {
        const diferenca = new Date(b.data).getTime() - new Date(a.data).getTime();
        return diferenca !== 0 ? diferenca : (b.id ?? 0) - (a.id ?? 0);
      })
      .slice(0, 8);
  }, [transacoes]);

  return (
    <Card className={styles.cartao}>
      <div className={styles.cabecalho}>
        <h2 className={styles.titulo}>Últimas movimentações</h2>
        <button type="button" className={styles.link} onClick={() => navigate('/movimentacoes')}>
          Ver todas →
        </button>
      </div>

      {ultimas.length === 0 ? (
        <div className={styles.vazio}>Nada lançado neste período ainda.</div>
      ) : (
        <div className={styles.lista}>
          {ultimas.map((transacao) => {
            const categoria = categorias.find((c) => c.id === transacao.categoriaId);
            const cor = categoria?.corIdentificacao?.trim() || '';
            const ehReceita = transacao.tipo === 'R';
            return (
              <div key={transacao.id} className={styles.item}>
                <span
                  className={styles.iconeCategoria}
                  style={{
                    color: cor || 'var(--textSecondary)',
                    background: cor ? hexToRgba(cor, 0.12) : 'var(--medium-gray)'
                  }}
                >
                  <Icon nome={categoria?.icone || 'category'} tamanho={18} />
                </span>
                <div className={styles.info}>
                  <span className={styles.descricao}>
                    {transacao.descricao || categoria?.nome || 'Sem descrição'}
                  </span>
                  <span className={styles.data}>{dataCurta(new Date(transacao.data))}</span>
                </div>
                <span className={`${styles.valor} ${ehReceita ? styles.valorReceita : ''}`}>
                  {ehReceita ? '+ ' : ''}
                  {valorParaTexto(Number(transacao.valor), true)}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
